import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

export const APPROVAL_STATUS = ['PENDING', 'APPROVED', 'REJECTED'] as const;

export const APPROVAL_STATUS_LABELS: Record<(typeof APPROVAL_STATUS)[number], string> = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const LEAVE_APPROVAL_STATUS_TONE: Record<(typeof APPROVAL_STATUS)[number], StatusColorTone> =
  {
    PENDING: APPROVAL_STATUS_TONE.pending,
    APPROVED: APPROVAL_STATUS_TONE.approved,
    REJECTED: APPROVAL_STATUS_TONE.rejected,
  };

export const LEAVE_REQUEST_TYPE = ['LEAVE_APPLICATION', 'ATTENDANCE_CLAIM'] as const;

export const LEAVE_REQUEST_TYPE_LABELS: Record<(typeof LEAVE_REQUEST_TYPE)[number], string> = {
  LEAVE_APPLICATION: 'Leave Application',
  ATTENDANCE_CLAIM: 'Present Request',
};

export const KEEP_PRESENT_REQUEST_OPTION_ID = 0;

export const LEAVE_REQUEST_TYPE_TONE: Record<(typeof LEAVE_REQUEST_TYPE)[number], StatusColorTone> =
  {
    LEAVE_APPLICATION: 'info',
    ATTENDANCE_CLAIM: 'success',
  };

export const LEAVE_TYPE_TONE: StatusColorTone = 'neutral';

export const APPLIED_DAYS_TONE: StatusColorTone = 'neutral';

export const DAY_UNIT = 'day';

interface SummaryCardConfig {
  key: 'total' | 'pending' | 'approved' | 'rejected';
  label: string;
}

export const SUMMARY_CARDS: SummaryCardConfig[] = [
  { key: 'total', label: 'Total Applications' },
  { key: 'pending', label: 'Pending' },
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
];

export const REVIEW_DECISION = { APPROVE: 'APPROVE', REJECT: 'REJECT' } as const;

export const REVIEW_COMMENT_MAX = 1000;

export const HIERARCHY_FILTER_TYPE = { AM: 'AM', ZM: 'ZM' } as const;

export const DEFAULT_PAGE_SIZE = 20;

export const DATE_FROM_FILTER_KEY = 'dateFrom';

export const DATE_TO_FILTER_KEY = 'dateTo';
